import { render, staticRenderFns } from "./project-extrafields-manual.vue?vue&type=template&id=b26a98f0&scoped=true"
import script from "./project-extrafields-manual.vue?vue&type=script&lang=js"
export * from "./project-extrafields-manual.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./project-extrafields-manual.vue?vue&type=style&index=1&id=b26a98f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26a98f0",
  null
  
)

export default component.exports